import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-remember-device',
  imports: [CommonModule, FormsModule,],
  templateUrl: './remember-device.html',
  styleUrl: './remember-device.scss',
})
export class RememberDevice {


    constructor(
    public authenticationService: AuthServiceService,
    public urlsService: UrlsService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private router: Router,
    private messageService: MessageService) {
  }

  ngOnInit() {
  }
}
